/**
 * TaxesModule - Vuex module for managing taxes/fees
 *
 * 2025-12-15: Added ledger account assignment support
 */
import axios from 'axios'
import customAxios from '@/axios/config'

export default {
  namespaced: true,
  state: {
    taxes: [],
    taxTypes: {},
    taxQuantifier: {},
    listingBasedFees: {},
    applicableToOptions: [],
    ledgerEnabled: false,
    ledgerAccounts: [],
    recognisedAtOptions: [],
  },
  mutations: {
    updateTaxes(state, payload) {
      state.taxes = payload
    },
    updateTaxTypes(state, payload) {
      state.taxTypes = payload
    },
    updateTaxQuantifier(state, payload) {
      state.taxQuantifier = payload
    },
    updateListingBasedFees(state, payload) {
      state.listingBasedFees = payload
    },
    updateApplicableToOptions(state, payload) {
      state.applicableToOptions = payload
    },
    updateLedgerEnabled(state, payload) {
      state.ledgerEnabled = payload
    },
    updateLedgerAccounts(state, payload) {
      state.ledgerAccounts = payload
    },
    updateRecognisedAtOptions(state, payload) {
      state.recognisedAtOptions = payload
    },
  },
  actions: {
    async fetchTaxes({ commit }) {
      const { data } = await axios.get('/api/taxes')
      commit('updateTaxes', data.taxes || [])
      commit('updateTaxTypes', data.tax_types || {})
      commit('updateTaxQuantifier', data.tax_quantifier || {})
      commit('updateListingBasedFees', data.listing_based_fees || {})
      commit('updateApplicableToOptions', data.applicable_to_options || [])
      commit('updateLedgerEnabled', data.ledger_enabled || false)
      commit('updateLedgerAccounts', data.ledger_accounts || [])
      commit('updateRecognisedAtOptions', data.recognised_at_options || [])
      return data
    },
    async createTax({ dispatch }, payload) {
      await customAxios.post('/api/taxes', payload)
      dispatch('fetchTaxes')
    },
    async updateTax({ dispatch }, { id, ...payload }) {
      await customAxios.put(`/api/taxes/${id}`, payload)
      dispatch('fetchTaxes')
    },
    async deleteTax({ dispatch }, id) {
      await customAxios.delete(`/api/taxes/${id}`)
      dispatch('fetchTaxes')
    },
  },
}
